export enum ArticleState {
  draft = "draft",
  published = "published",
  archived = "archived",
}

export const ArticleStates = [
  { value: ArticleState.draft, label: "Draft" },
  { value: ArticleState.published, label: "Published" },
  { value: ArticleState.archived, label: "Archived" },
];
